import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import axiosInstance from "helpers/api";
import { useAtom } from "jotai";
import { dealsAtom } from "jotai/LeadsJotaiInstance";
import { Form } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";

type Inputs = {
  deal_stage_name: string;
};
interface DealsAddStageModalProps {
  show: boolean;
  handleClose?: () => void;
  onHide?: () => void;
}

const DealsAddStageModal = ({ show, handleClose, onHide }: DealsAddStageModalProps) => {
  const closeModal = handleClose || onHide || (() => {});
  const [, setDeals] = useAtom(dealsAtom);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    const payload = {
      deal_stage_name: data.deal_stage_name,
    };

    try {
      const response = await axiosInstance.post("/deals/deal-stages", payload);
      toast.success(response.data.message);
      reset();
      setDeals(response.data.data);
      closeModal();
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <Modal show={show} onHide={closeModal} centered contentClassName="border">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header className="border-0 p-5">
          <h5 className="modal-title text-body-highlight fs-6 lh-sm">
            Create New Stage
          </h5>
          <Button
            variant="phoenix-secondary"
            className="ms-auto"
            onClick={handleClose}
            size="sm"
          >
            <FontAwesomeIcon icon={faTimes} className="text-danger" />
          </Button>
        </Modal.Header>
        <Modal.Body className="px-5 py-0 mb-2">
          <Form.Group className="mb-4">
            <Form.Label className="form-label-header mb-2">
              Column Name
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter column name"
              {...register("deal_stage_name")}
              required
            />
            {errors.deal_stage_name?.type === "required" && (
              <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                Name is required
              </p>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end align-items-center border-0 p-5">
          <Button
            variant="link"
            className="px-4 m-0 text-danger"
            onClick={handleClose}
          >
            Cencel
          </Button>
          <Button variant="primary" type="submit" className="px-4 m-0">
            Create New Stage
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DealsAddStageModal;
